import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import extract from '../../core/extract'
import PercentageDashboardPanel from '../../core/components/PercentageDashboardPanel'
import i18n from '../i18n'

class ClosingEventDashboardPanel extends Component {
    static propTypes = {
    }

    render() {
        const {dispatch, aggregations, ...others} = this.props

        const panelHeader = (title) => (
            <h4>{title}</h4>
        )

        return (
            <PercentageDashboardPanel
                header={panelHeader(i18n.closingEvent)}
                display={(m) => extract(i18n.stateEnum, m.value)}
                identify={(m) => m.count}
                value={aggregations.closingEvents}
                {...others} />
        )
    }
}

ClosingEventDashboardPanel = connect((state) => ({
	aggregations: state.ticket.aggregations
}))(ClosingEventDashboardPanel)

export default ClosingEventDashboardPanel


// WEBPACK FOOTER //
// ./lib/ticket/components/ClosingEventDashboardPanel.js